// extracted by mini-css-extract-plugin
export var alt = "ParagraphMediaCta-module--alt--086ba";
export var container = "ParagraphMediaCta-module--container--b4d53";
export var desktopOnly = "ParagraphMediaCta-module--desktopOnly--74f77";
export var main = "ParagraphMediaCta-module--main--7e4fe";
export var mobileOnly = "ParagraphMediaCta-module--mobileOnly--0a61f";
export var textLeft = "ParagraphMediaCta-module--textLeft--cc3e9";
export var visuallyHidden = "ParagraphMediaCta-module--visuallyHidden--3c361";